/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Backinstock2Inputs */

const he_statistics_backinstock2 = /** @type {(inputs: Statistics_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרים שחזרו למלאי`)
};

const en_statistics_backinstock2 = /** @type {(inputs: Statistics_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items back in stock`)
};

/**
* | output |
* | --- |
* | "Items back in stock" |
*
* @param {Statistics_Backinstock2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_backinstock2 = /** @type {((inputs?: Statistics_Backinstock2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Backinstock2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_backinstock2(inputs)
	return en_statistics_backinstock2(inputs)
});
export { statistics_backinstock2 as "statistics_backInStock" }